import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-info-skeleton',
  templateUrl: './info-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoSkeletonComponent {}
